import { render, staticRenderFns } from "./ProjectTestCases.vue?vue&type=template&id=526b1756&scoped=true&"
import script from "./ProjectTestCases.vue?vue&type=script&lang=js&"
export * from "./ProjectTestCases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526b1756",
  null
  
)

export default component.exports